module.exports = __webpack_public_path__ + "assets/5f7e735302479d2972666cace8ea1cbe.png";